import { Box, Typography, IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TITLE_BAR_HEIGHT } from '@/constants';
import { IndicatorLight } from './IndicatorLight';
import { useNavigate } from 'react-router';

const TitleBarRoot = styled(Box)(({ theme }) => ({
  height: TITLE_BAR_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  position: 'relative',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '0.7rem',
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 2,
}));

const Indicators = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  alignItems: 'center',
}));

export const TitleBar = ({
  title,
  onClose,
}: {
  title: string;
  onClose?: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <TitleBarRoot>
      <Indicators>
        <IndicatorLight delay={600} label="SYS" color="red" />
        <IndicatorLight delay={1400} label="TTY" color="yellow" />
        <IndicatorLight delay={2400} label="RUN" color="green" />
      </Indicators>

      <TitleText variant="h1">{title}</TitleText>

      <IconButton
        size="small"
        aria-label="close"
        onClick={() => {
          if (onClose) {
            onClose();
          } else {
            navigate('/');
          }
        }}
        sx={{
          color: 'primary.main',
          '&:hover': { color: 'secondary.main' },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </TitleBarRoot>
  );
};
